import { Checkbox, Flex } from 'components';
import { useTable } from '..';

import { OrderIcon, OrderIconWrapper, TableTh, TableThead, TableTr } from '../styles';
import { TableHeadProps } from '../types';

function TableHeadWrapper<ObjectType>({ properties, handleTriggerSelectMultipleRows, hideCheckbox, fixedTop }: TableHeadProps<ObjectType>) {
  // console.log('render table head');

  const { triggerSelectMultipleRows } = useTable();

  return (
    <TableThead>
      <TableTr>
        {properties.map((property, propertyIndex) =>
          !propertyIndex ? (
            <TableTh
              key={`thead-${propertyIndex.toString()}-${String(property.key)}`}
              data-key={`thead-${propertyIndex.toString()}-${String(property.key)}`}
              style={{ top: fixedTop || 0 }}
            >
              <Flex alignItems="center" pl={12}>
                {!hideCheckbox && (
                  <Flex flexGrow={0} mr="12px">
                    <Checkbox color="white" checked={triggerSelectMultipleRows} onChange={handleTriggerSelectMultipleRows} />
                  </Flex>
                )}

                {!!property.orderBy ? (
                  <Flex flexWrap="nowrap" alignItems="center" style={{ cursor: 'pointer' }} onClick={property.orderBy}>
                    {property.title}
                    <OrderIconWrapper>
                      <OrderIcon data-active={property.orderByActive} icon={property.orderByDirection === 'asc' ? 'menuDown' : 'menuUp'} />
                    </OrderIconWrapper>
                  </Flex>
                ) : (
                  <>{property.title}</>
                )}
              </Flex>
            </TableTh>
          ) : (
            <TableTh key={`thead-${propertyIndex.toString()}-${String(property.key)}`} style={{ top: fixedTop || 0 }}>
              {!!property.orderBy ? (
                <Flex flexWrap="nowrap" alignItems="center" style={{ cursor: 'pointer' }} onClick={property.orderBy}>
                  {property.title}
                  <OrderIconWrapper>
                    <OrderIcon data-active={property.orderByActive} icon={property.orderByDirection === 'asc' ? 'menuUp' : 'menuDown'} />
                  </OrderIconWrapper>
                </Flex>
              ) : (
                <>{property.title}</>
              )}
            </TableTh>
          )
        )}
      </TableTr>
    </TableThead>
  );
}

export default TableHeadWrapper;
